import { instanceToPlain } from 'class-transformer';
import { collection, doc, getDoc, getDocs, updateDoc } from 'firebase/firestore';
import { Laundry, LaundryGarment } from '../../entities';
import { Collections, db } from '../../utils/firebase.config';
import { converterOf } from '../../utils/firebase.utils';

export const useGarments = (laundryId: string) => {
  const laundriesCollection = collection(db, Collections.Laundries).withConverter(converterOf(Laundry));
  const laundryDoc = doc(laundriesCollection, laundryId);
  const garmentsColllection = collection(laundryDoc, Collections.Garments).withConverter(converterOf(LaundryGarment));

  const fetchAll = async (): Promise<LaundryGarment[]> => {
    const garmentsDocs = await getDocs(garmentsColllection);

    return garmentsDocs.docs.map((garmentDoc) => garmentDoc.data());
  };

  const update = async (garment: Partial<LaundryGarment> & { id: string }): Promise<LaundryGarment> => {
    const garmentDoc = doc(garmentsColllection, garment.id);
    const resource = await getDoc(garmentDoc);

    const instance = new LaundryGarment({ ...resource, ...garment });

    await updateDoc(garmentDoc, instanceToPlain(instance));

    return instance;
  };

  return { fetchAll, update };
};

export default useGarments;
